import CustomInput from "./CustomInput";
import { ReactComponent as Search } from 'assets/common/search.svg'
import { useEffect } from "react";
import { hsCodePopAtom, hsCodeResultAtom } from "atom/hsCode";
import { useAtomValue, useSetAtom } from "jotai";

interface IHsCode {
    hsCode: string | null;
    onChange: (value: string) => void;
    width?: string
    height?: number
    fontSize?: string
    InputClass?: string
    right?: string
}

const HsCode = ({ hsCode, onChange, width, fontSize, InputClass = '', height, right }: IHsCode) => {
    const setPopOpen = useSetAtom(hsCodePopAtom)
    const hsCodeResult = useAtomValue(hsCodeResultAtom);

    useEffect(() => {
        if (hsCodeResult) {
            onChange?.(hsCodeResult);
        }
    }, [hsCodeResult]);

    return (
        <div className={`flex-[1] relative ${width ? width : 'max-w-[320px]'}`}
            onClick={() => {
                setPopOpen(true)
            }}
        >
            <CustomInput
                className={InputClass}
                type="text"
                height={height ? height : 10}
                fontSize={fontSize ? fontSize : 'sm'}
                placeholder="HS CODE 검색"
                value={hsCode ?? ''}
                readonly
            />

            <div className={`top-0 ${right ? right : 'right-3'} absolute flex justify-center items-center h-full cursor-pointer`}>
                <Search />
            </div>
        </div>
    );
}

export default HsCode;
